import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function ListISEEUploaded(props) {
  const apiToken = useContext(TokenContext);
  const [ISEEList, setISEEList] = useState();
  const [ISEEListTemp, setISEEListTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [ISEEId, setISEEId] = useState();
  const [isUpdating, setIsUpdating] = useState(false);
  const [isPolling, setIsPolling] = useState(false);

useEffect(() => {
  setLoading(true);

  loadIsee();
}, []);

const loadIsee = async () => {
    try {
        const response = await Repo.getIseeListUploaded(apiToken);

        setISEEListTemp(response.data);

        const hasLoaded = response.data.some(x => x.state === "LOADED");

        if (!hasLoaded) {
            setIsPolling(false);
            setIsUpdating(false);
        }
    }
    catch (error) {
        console.log(error);
        setIsPolling(false);
        setIsUpdating(false);
    }
    finally {
        setLoading(false);
    }
};
  const startIseeValidation = async () => {
    setIsUpdating(true);

    const payload = {
      announcementId: null,
      tipo: 4,
    };

    Repo.startAggiornamento(apiToken, payload)
      .then((response) => {
        toggleModal(false);
         setIsPolling(true);
      })
      .catch((error) => {
        console.log(error);

        alert(
          error?.response?.data || "Errore durante l'avvio dell'aggiornamento",
        );
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

useEffect(() => {
    if (!isPolling) return;

    let timeout;

    const poll = async () => {
        await loadIsee();

        timeout = setTimeout(poll, 3000);
    };

    poll();

    return () => clearTimeout(timeout);
}, [isPolling]);



  return (
    <>
      <div>
        <h1>Lista ISEE</h1>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <p className="mb-0">
            Tutti gli ISEE caricati dagli utenti e non ancora validati
          </p>

          <div className="d-flex gap-2">
            <button
               className="btn btn-primary"
              onClick={() => toggleModal(true)}
              disabled={isUpdating || isPolling}
            >
              Avvia verifica automatica
            </button>

            <Link to="/lista_isee/logs">
              <button className="btn btn-outline-primary ml-2">
                Storico verifiche
              </button>
            </Link>
          </div>
        </div>
        <div className="container">
          {ISEEList && ISEEList.length > 0 ? (
            <>
              {/* Intestazione */}
              <div className="d-flex fw-bold border-bottom pb-2 mb-2">
                <div className="col-3">
                  <strong>Dati cittadino</strong>
                </div>
                <div className="col-2">
                  <strong>Codice Fiscale</strong>
                </div>
                <div className="col-2">
                  <strong>Data caricamento</strong>
                </div>
                <div className="col-2">
                  <strong>Valore ISEE caricato</strong>
                </div>
                <div className="col-1">
                  <strong>Anno</strong>
                </div>
                <div className="col-1">
                  <strong>Stato</strong>
                </div>
                <div className="col-1 text-right"></div>
              </div>

              {/* Lista */}
              {ISEEList.map((x, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center py-2 border-bottom"
                >
                  <div className="col-3">
                    {x.user?.firstName || "N/A"} {x.user?.lastName || "N/A"}
                  </div>
                  <div className="col-2">{x.user?.fiscalCode || "N/A"}</div>
                  <div className="col-2">{x.date || "N/A"}</div>
                  <div className="col-2">
                    {x.value
                      ? `${parseFloat(x.value).toLocaleString("it-IT")} €`
                      : "N/A"}
                  </div>
                  <div className="col-1">{x.year || "N/A"}</div>
                  <div className="col-1">
                    {x.state === "VALIDATED" && (
                      <span className="badge badge-success">Validato</span>
                    )}

                    {x.state === "ERROR" && (
                      <span className="badge badge-danger">Errore</span>
                    )}

                    {!["VALIDATED", "ERROR"].includes(x.state) && (
                      <span className="badge badge-secondary">{x.state}</span>
                    )}
                  </div>
                  <div className="col-1 text-right">
                    <Link to={`/lista_isee/verifica_isee?idIsee=${x.id}`}>
                      <button
                        className="btn btn-outline-primary p-2"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Dettaglio"
                      >
                        Dettaglio
                      </button>
                    </Link>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="text-center py-3">
              <b>Non ci sono ISEE da verificare.</b>
            </div>
          )}

          {ISEEListTemp && (
            <Pagination
              items={ISEEListTemp}
              setCurrentItems={setISEEList}
              itemsPerPage={50}
            />
          )}
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Aggiornamento automatico ISEE"
        body="Confermi di voler avviare la validazione automatica degli ISEE caricati?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => startIseeValidation()}
      />
     {loading && <Loader />}
    </>
  );
}

export default ListISEEUploaded;
